import Vue from 'vue';
import { _ } from 'underscore'

export const state = {
  loading: false,
  ledger: null,
  nominals: [],
  taxes: [],
  invoiceItems: [],
  invoiceGross: 0,
  invoiceNet: 0,
  vatTotals: [],
  agedDebt: null,
  bankDetails: null,
  ddOrganisationId: null,
  reverseTransaction: null,
  endBankAccount: null,
  paymentLogs: null,
  billLogs: null,
  payments: [],
  billOH: [],
  collectionPayments: [],
  runDetails: null,
  billDetails: null,
  chargeDetails: null,
  usage: null,
  bills: [],
  statementsOH: [],
  billRuns: [],
  charges: [],
  billRunStatus: "Completed",
  hideBatchesOfOne: true,
  paymentRuns: null,
  collectionRuns: null,
  salesTransactions: [],
  writeOffAmount: null,
  writeOffReason: null,
  allSelectedForWriteOff: false,
  selectedForWriteOff: [],
  reversalAmount: null,
  reversalReason: null,
  allSelectedForReversal: false,
  selectedForReversal: [],
  fixedPayments: [],
  bacsCalendar: null,
  fixedPaymentEditMode: false,
  selectedBillsforBulkDelete: [],


}

export default {
  state: {
    loading: false,
    aruddCodes: [],
    aruddCodesLoading: false,
    ddCharges: [],
    ddChargesLoading: false,
    ledger: null,
    nominals: [],
    taxes: [],
    invoiceItems: [],
    invoiceGross: 0,
    invoiceNet: 0,
    vatTotals: [],
    agedDebt: null,
    bankDetails: null,
    ddOrganisationId: null,
    reverseTransaction: null,
    endBankAccount: null,
    paymentLogs: null,
    billLogs: null,
    payments: [],
    billOH: [],
    collectionPayments: [],
    runDetails: null,
    billDetails: null,
    chargeDetails: null,
    usage: null,
    bills: [],
    statementsOH: [],
    billRuns: [],
    charges: [],
    billRunStatus: {
      value: "Completed",
      name: "Completed",
    },
    hideBatchesOfOne: true,
    paymentRuns: null,
    collectionRuns: null,
    salesTransactions: [],
    writeOffAmount: null,
    writeOffReason: null,
    allSelectedForWriteOff: false,
    selectedForWriteOff: [],
    reversalAmount: null,
    reversalReason: null,
    allSelectedForReversal: false,
    selectedForReversal: [],
    fixedPayments: [],
    bacsCalendar: null,
    fixedPaymentEditMode: false,
    selectedBillsforBulkDelete: [],
  },
  mutations: {
    updateLedger(state, ledger) {
      state.ledger = ledger;
    },
    updateUsage(state, usage) {
      state.usage = usage;
    },
    updateNominals(state, nominals) {
      state.nominals = nominals;
    },
    updateTaxes(state, taxes) {
      state.taxes = taxes
    },
    updateInvoiceItems(state, items) {
      state.invoiceItems = items
    },
    updateInvoiceGross(state, gross) {
      state.invoiceGross = gross
    },
    updateInvoiceNet(state, net) {
      state.invoiceNet = net
    },
    updateVatTotals(state, totals) {
      state.vatTotals = totals
    },
    updateBills(state, bills) {
      state.bills = bills;
    },
    appendBills(state, bills) {
      state.bills = [...state.bills, ...bills];
    },
    updateBillRuns(state, billRuns) {
      state.billRuns = billRuns;
    },
    updateBillRunsContinuation(state, billRuns) {
      state.billRuns = _.union(state.billRuns, billRuns);
    },
    updateCharges(state, charges) {
      state.charges = charges;
    },
    updateAgedDebt(state, agedDebt) {
      state.agedDebt = agedDebt;
    },
    updateBankDetails(state, bankDetails) {
      state.bankDetails = bankDetails
      var lodgementWithDdOrg = _.find(_.sortBy(bankDetails, "EffectiveFrom").reverse(), function (lodgement) {
        return lodgement.hasOwnProperty('DdOrganisationId') && lodgement.DdOrganisationId
      })
      state.ddOrganisationId = lodgementWithDdOrg != undefined ? lodgementWithDdOrg.DdOrganisationId : null
    },
    updateDdOrganisationId(state, org) {
      state.ddOrganisationId = org
    },
    updateReverseTransaction(state, reverseTransaction) {
      state.reverseTransaction = reverseTransaction;
    },
    updateEndBankAccount(state, account) {
      state.endBankAccount = account;
    },
    updatePaymentLogs(state, paymentLogs) {
      state.paymentLogs = null;
      state.paymentLogs = paymentLogs;
    },
    updateBillLogs(state, billLogs) {
      state.billLogs = null;
      state.billLogs = billLogs;
    },
    updatePayments(state, payments) {
      state.payments = null;
      state.payments = payments;
    },
    updateBillOH(state, billOH) {
      state.billOH = billOH;
    },
    updateBillOHContinuation(state, billOH) {
      state.billOH = _.union(state.billOh, billOH)
    },
    updateCollectionPayments(state, collectionPayments) {
      state.collectionPayments = null;
      state.collectionPayments = collectionPayments;
    },
    updateRunDetails(state, runDetails) {
      state.runDetails = runDetails;
    },
    updateBillDetails(state, billDetails) {
      state.billDetails = billDetails;
    },
    updateChargeDetails(state, chargeDetails) {
      state.chargeDetails = chargeDetails;
    },
    updateBillRunStatus(state, status) {
      state.billRunStatus = status
    },
    updateHideBatchesOfOne(state, bool) {
      state.hideBatchesOfOne = bool
    },
    updatePaymentRuns(state, runs) {
      state.paymentRuns = runs
    },
    updateCollectionRuns(state, runs) {
      state.collectionRuns = runs
    },
    updateSalesTransactions(state, transactions) {
      state.salesTransactions = transactions
    },
    updateWriteOffAmount(state, amount) {
      state.writeOffAmount = amount
    },
    updateWriteOffReason(state, reason) {
      state.writeOffReason = reason
    },
    updateAllSelectedForWriteOff(state, bool) {
      state.allSelectedForWriteOff = bool
    },
    updateSelectedForWriteOff(state, selected) {
      state.selectedForWriteOff = selected
    },
    updateReversalAmount(state, amount) {
      state.reversalAmount = amount
    },
    updateReversalReason(state, reason) {
      state.reversalReason = reason
    },
    updateAllSelectedForReversal(state, bool) {
      state.allSelectedForReversal = bool
    },
    updateSelectedForReversal(state, selected) {
      state.selectedForReversal = selected
    },
    updateStatementsOH(state, statements) {
      state.statementsOH = statements
    },
    updateStatementsOHContinuation(state, statements) {
      state.statementsOH = _.union(state.statementsOH, statements)
    },
    updateFixedPayments(state, fixedPayments) {
      state.fixedPayments = fixedPayments
    },
    updateBacsCalendar(state, bacsCalendar) {
      state.bacsCalendar = bacsCalendar
    },
    updateFixedPaymentEditMode(state, bool) {
      state.fixedPaymentEditMode = bool
    },
    updateSelectedBillsforBulkDelete(state, val) {
      state.selectedBillsforBulkDelete = val
    },
    updateAruddCodes(state, codes) {
      state.aruddCodes = codes;
    },
    updateAruddCodesLoading(state, isLoading) {
      state.aruddCodesLoading = isLoading;
    },
    updateDdCharges(state, charges) {
      state.ddCharges = charges;
    },
    updateDdChargesLoading(state, isLoading) {
      state.ddChargesLoading = isLoading;
    },
  },
  actions: {
    getLedger({ rootState, commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/accounts/" + rootState.customers.customer.AccountId + "/ledger", {
          withCredentials: true
        })
        .then(response => {
          // this.ledger = response.data;
          commit('updateLedger', response.data);
        });
    },
    getUsage({ rootState, commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.billbot.domain + "/api/v1/unbilled/" + rootState.customers.customer.Id, {
          withCredentials: true
        })
        .then(response => {
          commit('updateUsage', response.data);
        });
    },
    getNominals({ commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/nominals", {
          withCredentials: true
        })
        .then(response => {
          commit('updateNominals', response.data.Records);
        });
    },
    getTaxes({ commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/taxes", {
          withCredentials: true
        })
        .then(response => {
          commit('updateTaxes', response.data.Records);
        });
    },
    getBills({ rootState, commit, dispatch }, token) {
      let path = `https://${Vue.config.honeycomb.billbot.domain}/api/v1/statements?customerId=${rootState.customers.customer.Id}${token ? "&continuationToken=" + encodeURIComponent(token) : ""}`
      Vue.prototype.$http
        .get(path, {
          withCredentials: true
        })
        .then(response => {
          if (token) {
            commit('appendBills', response.data.Records);
          } else {
            commit('updateBills', response.data.Records);
          }
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getBills', response.data.ContinuationToken)
          }
        });
    },
    getBillRuns({ commit, dispatch, state }) {
      state.loading = true
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.billbotbillrun.domain + "/api/v1/BillRuns?rows=500&billRunStatus=" + state.billRunStatus.value, {
          withCredentials: true
        })
        .then(response => {
          commit('updateBillRuns', response.data.Records)
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getBillRunsContinuation', response.data.ContinuationToken)
          }
          state.loading = false
        })
    },
    getBillRunsContinuation({ commit, dispatch, state }, token) {
      var formData = new FormData();
      formData.append('rows', 500)
      formData.append('billRunStatus', state.billRunStatus.value)
      formData.append('continuationToken', token)

      Vue.prototype.$http
        .post(`https://${Vue.config.honeycomb.billbotbillrun.domain}/api/v1/BillRuns`, formData, {
          withCredentials: true
        })
        .then(response => {
          commit('updateBillRunsContinuation', response.data.Records)
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getBillRunsContinuation', response.data.ContinuationToken)
          }
        })
    },
    deleteBill({ state }) {
      return Vue.prototype.$http
        .put(
          "https://" +
          Vue.config.honeycomb.billbotbillrun.domain +
          "/api/v1/BillRuns/undo",
          {
            BillIds: [state.billDetails.Id]
          },
          {
            withCredentials: true
          }
        )
    },
    getCharges({ rootState, commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.billbot.domain + "/api/v1/charges?customerId=" + rootState.customers.customer.Id, {
          withCredentials: true
        })
        .then(response => {
          commit('updateCharges', response.data.Records);
        });
    },
    getAgedDebt({ rootState, commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/reports/ageddebt?accountId=" + rootState.customers.customer.AccountId + "&brackets=" + Vue.config.honeycomb.agedDebt.brackets.join(','), {
          withCredentials: true
        })
        .then(response => {
          // this.agedDebt = response.data[0];
          commit('updateAgedDebt', response.data[0]);
        });
    },
    getBankDetails({ rootState, commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.ddbot.domain + "/api/v1/lodgements?accountId=" + rootState.customers.customer.AccountId, {
          withCredentials: true
        })
        .then(response => {
          // this.bankDetails = response.data;
          commit('updateBankDetails', response.data);
        });
    },
    getPaymentLogs({ commit }, details) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.logbot.domain + "/api/v1/Messages/" + details.Id, {
          withCredentials: true
        })
        .then(response => {
          commit('updatePaymentLogs', response.data);
          commit('updateRunDetails', details);
        });
    },
    getBillLogs({ commit }, details) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.logbot.domain + "/api/v1/Messages/" + details.BillRunId, {
          withCredentials: true
        })
        .then(response => {
          commit('updateBillLogs', response.data);
          commit('updateRunDetails', details);
        });
    },
    getPayments({ commit }, details) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/BankTransactions?batchId=" + details.Id, {
          withCredentials: true
        })
        .then(response => {
          commit('updatePayments', response.data.Records);
          commit('updateRunDetails', details);
        });
    },
    getBillOH({ commit, dispatch, state }, details) {
      state.loading = true;
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.billbot.domain + "/api/v1/OnHold?rows=500&billRunId=" + details.BillRunId, {
          withCredentials: true
        })
        .then(response => {
          commit('updateBillOH', response.data.Records);
          commit('updateRunDetails', details);
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getBillOHContinuation', { billRunId: details.BillRunId, token: response.data.ContinuationToken });
          }
          state.loading = false;
        });
    },
    getBillOHContinuation({ commit, dispatch }, details) {
      Vue.prototype.$http
        .get(`https://${Vue.config.honeycomb.billbot.domain}/api/v1/OnHold?rows=500&billRunId=${details.billRunId}&continuationToken=${encodeURIComponent(details.token)}`, {
          withCredentials: true
        })
        .then(response => {
          commit('updateBillOHContinuation', response.data.Records);
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getBillOHContinuation', { billRunId: details.billRunId, token: response.data.ContinuationToken });
          }
        });
    },
    getOHReport({ commit, dispatch, state }) {
      state.loading = true;
      state.statementsOH = [];
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.billbot.domain + "/api/v1/statements/onHold?rows=500", {
          withCredentials: true
        })
        .then(response => {
          commit('updateStatementsOH', response.data.Records);
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getOHReportContinuation', response.data.ContinuationToken);
          }
          state.loading = false;
        });
    },
    getOHReportContinuation({ commit, dispatch }, token) {
      Vue.prototype.$http
        .get(`https://${Vue.config.honeycomb.billbot.domain}/api/v1/statements/onHold?rows=500&continuationToken=${encodeURIComponent(token)}`, {
          withCredentials: true
        })
        .then(response => {
          commit('updateStatementsOHContinuation', response.data.Records);
          if (response.data.hasOwnProperty('ContinuationToken')) {
            dispatch('getOHReportContinuation', response.data.ContinuationToken);
          }
        });
    },
    getCollectionPayments({ commit }, details) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/BankTransactions?collectionId=" + details.Id, {
          withCredentials: true
        })
        .then(response => {
          commit('updateCollectionPayments', response.data.Records);
          commit('updateRunDetails', details);
        });
    },
    getPaymentRuns({ commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.ddbot.domain + "/api/v1/PaymentGenerationRuns", {
          withCredentials: true
        })
        .then(response => {
          commit('updatePaymentRuns', response.data.Records);
        });
    },
    getSalesTransactions({ commit, rootState }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.moneybot.domain + "/api/v1/SalesTransactions?accountId=" + rootState.customers.customer.AccountId, {
          withCredentials: true
        })
        .then(response => {
          commit('updateSalesTransactions', response.data.Records);
        });
    },
    getFixedPayments({ rootState, commit }) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.ddbot.domain + "/api/v1/fixed-payments?accountId=" + rootState.customers.customer.AccountId, {
          withCredentials: true
        })
        .then(response => {
          commit('updateFixedPayments', response.data);
        });
    },
    getBacsCalendar({ commit }, requestedDate) {
      Vue.prototype.$http
        .get("https://" + Vue.config.honeycomb.ddbot.domain + "/api/v1/bacs-calendar/" + requestedDate, {
          withCredentials: true
        })
        .then(response => {
          commit('updateBacsCalendar', response.data);
        });
    },
    getAruddCodes({ commit }) {
      commit('updateAruddCodesLoading', true);
      return Vue.prototype.$http
        .get(`https://${Vue.config.honeycomb.ddbot.domain}/api/v1/aruddCodes`, { withCredentials: true })
        .then(response => {
          commit('updateAruddCodes', response.data);
          commit('updateAruddCodesLoading', false);
        });
    },
    getDdCharges({ commit }) {
      commit('updateDdChargesLoading', true);
      return Vue.prototype.$http
        .get(`https://${Vue.config.honeycomb.ddbot.domain}/api/v1/failedDdPaymentCharges`, { withCredentials: true })
        .then(response => {
          commit('updateDdCharges', response.data);
          commit('updateDdChargesLoading', false);
        });
    },
    updateDdCharge({ dispatch }, charge) {
      return Vue.prototype.$http.put(`https://${Vue.config.honeycomb.ddbot.domain}/api/v1/failedDdPaymentCharges/${charge.Code}`, charge, { withCredentials: true }).then(() => {
        dispatch('getDdCharges');
        });
    },
  }
}